// Barra do topo com frase única no computador: lá o carrossel fica display:none, e o
// slideshow-component do Dawn continuaria girando — sem slide visível, o autoRotateSlides dele
// quebra ("Cannot read properties of undefined (reading 'classList')") a cada rodada. Pausa no
// computador e volta a girar no celular. Só carrega quando a frase única está preenchida.
await customElements.whenDefined("slideshow-component");

const mq = window.matchMedia("(min-width: 990px)");
const carrosseis = () => document.querySelectorAll(".ds-topbar__inner--com-fixa slideshow-component");

const aplicar = () => {
  for (const s of carrosseis()) {
    if (typeof s.pause !== "function" || typeof s.play !== "function") continue;
    if (mq.matches) s.pause();
    else if (s.slider?.getAttribute("data-autoplay") === "true") s.play();
  }
};

aplicar();
mq.addEventListener("change", aplicar);
